import React from 'react';
import { Progress } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarehouse } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import {
    createDataSource, createGridOptions, DataGrid, indexCellRenderer, LinkCellRenderer, TextFilterDefaults,
} from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, { agGridConstants, ApiRoutes, AppNavPaths } from '../Common';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';

class ResourceKitIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    componentDidMount() {
        return this.populateState();
    }

    populateState = async () => {
        const [chargeTypes] = await Promise.all([
            httpClient.js(ApiRoutes.typeAheads.chargeTypes()),
        ]);

        const gridOptions = createGridOptions(this);

        gridOptions.components = {
            selectFilter: DataGridSelectFilter,
            selectFloatingFilter: DataGridSelectFloatingFilter,
            nameRenderer: LinkCellRenderer,
        };

        const status = [
            { label: 'Active', value: 'true' },
            { label: 'Inactive', value: 'false' },
        ];
        const statusFilterParams = {
            suppressFilterButton: true,
            options: status,
            optionsLabel: 'label',
            optionsValue: 'value',
        };

        gridOptions.columnDefs = [
            {
                flex: 0,
                width: 80,
                headerName: '',
                valueGetter: 'node.id',
                sortable: false,
                hide: true,
                cellRenderer: indexCellRenderer,
            },
            {
                colId: 'Name',
                sortable: true,
                headerName: 'Name',
                field: 'name',
                filter: agGridConstants.columnFilterTypes.text,
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                sort: { direction: 'asc', priority: 0 },
                cellRenderer: 'nameRenderer',
                cellRendererParams: {
                    to: (id) => `${AppNavPaths.ResourceKit}/${id}`,
                    nameField: 'name',
                    idField: 'id',
                    title: 'View this Resource Kit',
                },
            },
            {
                colId: 'Description',
                sortable: true,
                headerName: 'Description',
                field: 'description',
                filter: agGridConstants.columnFilterTypes.text,
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                sort: { direction: 'asc', priority: 0 },
            },
            {
                colId: 'ChargeTypeId',
                sortable: false,
                headerName: 'Charge Types',
                field: 'chargeTypes',
                filter: 'selectFilter',
                floatingFilter: true,
                flex: 1.5,
                filterParams: {
                    labelText: 'Filter by charge type',
                    options: chargeTypes,
                    optionsLabel: 'label',
                    optionsValue: 'value',
                },
                floatingFilterComponent: 'selectFloatingFilter',
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                    options: chargeTypes,
                    optionsLabel: 'label',
                    optionsValue: 'value',
                },
            },
            {
                colId: 'IsActive',
                headerName: 'Status',
                field: 'isActive',
                sortable: true,
                tooltipField: 'status',
                filter: 'selectFilter',
                floatingFilter: true,
                filterParams: statusFilterParams,
                floatingFilterComponent: 'selectFloatingFilter',
                floatingFilterComponentParams: statusFilterParams,
            },
        ];

        const ds = createDataSource(ApiRoutes.resourceKit.search(), gridOptions);

        this.setState({
            loading: false,
            gridOptions,
            dataSource: ds,
        });
    };

    render() {
        if (this.state.loading) return (<Progress />);
        const { rowData, gridOptions } = this.state;

        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon
                        icon={faWarehouse}
                        className="mr-2 text-muted"
                    />
                    <span>Resource Kits</span>
                </PageHeading>
                <DataGridToolbar
                    entity="resourceKit"
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    onAdd={() => this.context.history.push(`${AppNavPaths.ResourceKitNew}`)}
                    addLabel="Add Resource Kit"
                />
                <DataGrid
                    domLayout="normal"
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                />
            </PageWrap>
        );
    }
}
export default ResourceKitIndex;
